import config from '@/config';
import EnvEnum from '@/enums/env';

const isStaging = () => {
    return config.APP_ENV === EnvEnum.STAGING;
};

export default isStaging;
